import {Component, OnInit, ViewContainerRef} from "@angular/core";
import {Constants} from '../../../../util/Constants';
import {AnonymousService} from '../../../../services/anonymous-service';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {Router} from '@angular/router';
import {UserService} from '../../../../services/users-service/user-service';
import {AuthService} from '../../../../services/auth-service/auth-service.service';
import {ToastService} from '../../../../util/toast-service/toast.service';
import {ErrorService} from '../../../../util/error_service/error.service';

@Component({
  selector: 'app-admin-profile',
  templateUrl: './admin-profile.component.html',
  styleUrls: ['./admin-profile.component.scss']
})

export class AdminProfileComponent implements OnInit {

  pageTitle = 'Profile';
  public switchCreate: boolean;
  public roles: any;
  public userDataResponse: any;
  public resMsg: any;
  public message: any;
  public isNotEdit: boolean;
  public edit_text: string;

  public profile: any;
  public userFormData: any = {
    lastName: '',
    firstName: '',
    mobile: '',
    email: '',
    roleId: ''
  };

  constructor( public _sharedService: SharedService, public router: Router, public anonymousService: AnonymousService,
               public agentService: UserService, public authService: AuthService, public toast: ToastService, public error: ErrorService) {

    this._sharedService.emitChange(this.pageTitle);
    this.profile = JSON.parse(localStorage.getItem(Constants.PROFILE)).data[0];
    this.switchCreate = true;
    this.getRoles();
    this.isNotEdit = true;
    this.edit_text = 'Edit Profile';
    this.initializeForm();
  }

  ngOnInit() {
    // console.log("*************** profile details **************");
    // console.log(this.profile);
  }

  onSubmit() {
    // console.log(this.userFormData);
    this.updateUser();
  }

  public initializeForm() {
    this.userFormData.firstName = this.profile.firstName;
    this.userFormData.lastName = this.profile.lastName;
    this.userFormData.mobile = this.profile.mobile;
    this.userFormData.email = this.profile.email;
    this.userFormData.address = this.profile.address;
    this.userFormData.roleId = this.profile.role.id;
  }

  getProfile = () => {
    this._sharedService.getProfile(this.profile.email).subscribe(
      response => {
        // console.log(response.data);
        if (response.status == 200) {
          localStorage.setItem(Constants.PROFILE, '');
          localStorage.setItem(Constants.PROFILE, JSON.stringify(response));
        }
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.updateUser, err);
        // console.log("Agent profile failed response");
        // console.log(err);
      }
    )
  }

// update users
  updateUser = () => {
    this.agentService.updateAdmin(this.userFormData, this.profile.id).subscribe(
      response => {
        if (response.status == 200) {
          this.userDataResponse = response.data;
          this.message = Constants.USER_UPDATED_SUCCESSFULLY;
          this.editToggle();
          this.toast.showSuccess(this.message, 'Success');
          this.getProfile();
        }
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.updateUser, err);
        // console.log(msg.errorMsg);
        this.toast.showError(msg.message, 'Error');
      }
    )
  }

  // get roles
  getRoles = () => {
    this.anonymousService.getRoles().subscribe(
      response => {
        // console.log("get roles function")
        // console.log(response);
        this.roles = response.data;
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.getRoles, err);
        // console.log(msg.message);
      }
    )
  }

  editToggle() {
    if (this.isNotEdit) {
      this.edit_text = 'Cancel';
      this.isNotEdit = false;
    } else {
      this.isNotEdit = true;
      this.edit_text = 'Edit Profile';
    }
  }
  //
  // changePassword() {
  //   this.router.navigate(['admin/change-password']);
  // }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/User management/admin-profile/admin-profile.component.ts